import { FC } from 'react';

import { Spinner } from '@bringg/react-components';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { OrderHistoryFiltersType } from '@bringg/types';
import { useQuery } from 'react-query';

type CountProps = {
	count: number;
	limit: number;
	page: number;
	isFirstPage: boolean;
	outOfText: string;
};

const Count: FC<CountProps> = ({ count, limit, page, isFirstPage, outOfText }) => {
	const currentPosition = (): string => {
		if (count === 0) {
			return '0';
		}

		if (isFirstPage) {
			return `${1}-${limit > count ? count : limit}`;
		}

		const pageLimit = page * limit;
		const endNumber = pageLimit < count ? pageLimit : count;

		return `${(page - 1) * limit}-${endNumber}`;
	};

	return (
		<div>
			{currentPosition()} {outOfText} {count}
		</div>
	);
};

export interface CountDisplayWithFetchProps {
	limit: number;
	page: number;
	isFirstPage: boolean;
	filters: OrderHistoryFiltersType;
	countLoadFailedText: string;
	countOutOfText: string;
}

export const CountDisplayWithFetch: FC<CountDisplayWithFetchProps> = ({
	limit,
	page,
	isFirstPage,
	filters,
	countLoadFailedText,
	countOutOfText
}) => {
	const { isLoading, data, error } = useQuery<{ count: number }>(
		['historyTasksMetadata', filters],
		async (): Promise<{ count: number }> => {
			if (filters.late) {
				const converted = filters.late.map((val: number | boolean) => !!val);

				filters.late = converted;
			}

			return getRootEnv().dashboardSdk.sdk.tasks.getHistoryTasksMetadata(filters);
		},
		{
			refetchOnWindowFocus: false,
			staleTime: Infinity,
			enabled: true
		}
	);

	if (isLoading) {
		return <Spinner size="small" />;
	}

	if (error) {
		return <div>{countLoadFailedText}</div>;
	}

	return <Count count={data?.count} limit={limit} page={page} isFirstPage={isFirstPage} outOfText={countOutOfText} />;
};
